import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useCookies } from 'vue3-cookies'

/**
 * The cookie is shared with traforama — same name, same two words — so a publisher who
 * moves between the apps keeps one sidebar. Change either and the two drift apart.
 */
const STATUS_KEY = 'sidebar_status'
const CLOSED = 'closed'
const OPENED = 'opened'

/**
 * Whether the sidebar is pinned open, remembered across reloads.
 *
 * `withoutAnimation` is set when something other than the user moved it — a resize past
 * the breakpoint — because the 0.28s slide reads as a glitch when nothing was clicked.
 */
export const useSidebarStore = defineStore('adok-sidebar', () => {
  const { cookies } = useCookies()

  const opened = ref(cookies.get(STATUS_KEY) !== CLOSED)
  const withoutAnimation = ref(false)

  function set(next: boolean, animate: boolean) {
    opened.value = next
    withoutAnimation.value = !animate
    cookies.set(STATUS_KEY, next ? OPENED : CLOSED)
  }

  const toggle = () => set(!opened.value, true)
  const open = (animate = true) => set(true, animate)
  const close = (animate = true) => set(false, animate)

  return { opened, withoutAnimation, toggle, open, close }
})
